/**
 * RM-359: the chat a link asks RM AI to open (/ai?chat=<conversation id>, RM's follow-up on an
 * unfinished request started in RM AI). Only something shaped like a conversation id is used; the
 * server opens only the signed-in member's own chat either way.
 *
 * @param {Record<string, unknown>} query - the route's query
 * @returns {string|null}
 */
export function linkedChatId(query) {
  const id = Array.isArray(query?.chat) ? query.chat[0] : query?.chat

  return typeof id === 'string' && /^[a-f0-9]{24}$/i.test(id) ? id : null
}
